import appConfig from "@/app.config";
import Model from './model.js';

export default class Translation extends Model{
    constructor(){
        super();
        this.appLocales = appConfig.locales
        this.current_locale = ''
    }

    setLocale(modelLocales){
        for (const locale of this.appLocales.map((l)=>l.code)) {
            if(modelLocales.findIndex((l)=>l == locale) != -1){
                this.current_locale = locale
                break;
            }
        }
    }

    get Title(){
        return this['title_' + this.current_locale]
    }
}